<template>
    <v-container v-if="loadSkeleton">
        <SkeletonLoader ruta="tramites" tipo="table-heading, card, table-tfoot"></SkeletonLoader>
    </v-container>
    <v-container v-else class="justify-center align-center  ">
        <v-card flat>
            <v-card-title class="text-h5 font-weight-bold">
                <v-icon color="primary" class="mr-3" size="34">mdi-file-document-multiple-outline</v-icon>
                Mis trámites
                <v-spacer></v-spacer>
                <v-btn @click="traerTramites" :loading="loading" color="primary" class="pa-5 elevation-0"><v-icon
                        class="mr-1">mdi-refresh</v-icon>
                    ACTUALIZAR</v-btn>
            </v-card-title>
        </v-card>
        <v-card class="rounded-0 ma-2" outlined>
            <v-card-title>
                <div class="font-weight-bold primary--text"
                    :class="$vuetify.breakpoint.smAndUp ? 'text-h5' : 'text-h6'">
                    Listado de trámites
                </div>
                <v-spacer></v-spacer>
                <v-text-field v-if="$vuetify.breakpoint.smAndUp" v-model="search" append-icon="mdi-magnify"
                    label="Buscar trámites" single-line hide-details></v-text-field>
            </v-card-title>

            <!-- Footer personalizado arriba de la tabla -->
            <v-card-text class="d-flex align-center px-4 py-2"
                style="border-top: 1px solid #E0E0E0; border-bottom: 1px solid #E0E0E0;"
                :class="$vuetify.breakpoint.mdAndUp ? ' justify-end' : 'flex-column'">
                <div class="d-flex align-end" :class="$vuetify.breakpoint.smAndDown ? 'mb-2' : 'mr-5'">
                    <span class="font-weight-bold text-body-2 mr-2">Filas por página:</span>
                    <v-text-field v-model.number="itemsPerPage" type="number" dense hide-details
                        style="max-width: 80px;" :min="5" :max="50"></v-text-field>
                </div>

                <div class="d-flex align-center justify-center">
                    <span class="text-body-2 mr-3">
                        {{ getPageRangeText() }}
                    </span>
                    <v-btn class="mx-1" fab x-small color="primary" :disabled="page === 1" @click="page = 1"
                        style="z-index: 3;">
                        <v-icon color="white" small>mdi-page-first</v-icon>
                    </v-btn>
                    <v-btn class="mx-1" fab x-small color="primary" :disabled="page === 1" @click="page--"
                        style="z-index: 3;">
                        <v-icon color="white" small>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-btn class="mx-1" fab x-small color="primary" :disabled="page >= totalPages" @click="page++"
                        style="z-index: 3">
                        <v-icon color="white" small>mdi-chevron-right</v-icon>
                    </v-btn>
                    <v-btn class="mx-1" fab x-small color="primary" :disabled="page >= totalPages"
                        @click="page = totalPages" style="z-index: 3">
                        <v-icon color="white" small>mdi-page-last</v-icon>
                    </v-btn>
                </div>
            </v-card-text>

            <v-data-table :headers="headers" :items="paginatedItems" :search="search" :loading="loading"
                :item-class="getItemClass" hide-default-footer disable-pagination>
                <template v-slot:item.actions="{ item }">
                    <div class="d-flex flex-row justify-center">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn fab text color="primary" @click="descargarPdf(item.rutadocumento)" class="ma-1"
                                    :loading="descargando === item.rutadocumento" :disabled="!!descargando"
                                    v-bind="attrs" v-on="on">
                                    <v-icon>mdi-download</v-icon>
                                </v-btn>
                            </template>
                            <span>descargar PDF</span>
                        </v-tooltip>
                    </div>
                </template>
                <template v-slot:item.pdfarchivos="{ item }">
                    <div class="d-flex flex-row justify-center" v-if="item.rutadocumento2">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text fab color="primary" @click="descargarPdf(item.rutadocumento2)" class="ma-1"
                                    :loading="descargando === item.rutadocumento2" :disabled="!!descargando"
                                    v-bind="attrs" v-on="on">
                                    <v-icon>mdi-download</v-icon>
                                </v-btn>
                            </template>
                            <span>descargar PDF</span>
                        </v-tooltip>
                    </div>
                </template>
                <template v-slot:item.estado="{ item }">
                    <div>
                        <v-chip small :color="getColor(item.estado)" class="font-weight-bold">
                            <div class="white--text">
                                {{ item.estado }}
                            </div>
                            <template
                                v-if="((item.estado !== 'APROBADO') && (item.estado !== 'EN CURSO') && (item.estado !== 'PENDIENTE')) && item.observaciones">
                                <v-tooltip bottom color="darken">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon color="white" class="ml-2" size="20" v-bind="attrs" v-on="on">
                                            mdi-information-outline
                                        </v-icon>
                                    </template>
                                    <span>{{ item.observaciones }}</span>
                                </v-tooltip>
                            </template>
                        </v-chip>
                    </div>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>


<script>
import { mapActions, mapGetters } from 'vuex';
import SkeletonLoader from '@/components/alerts/SkeletonLoader.vue';


export default {
    name: 'Tramites',

    components: {
        SkeletonLoader
    },
    data() {
        return {
            search: '',
            itemsPerPage: 5,
            page: 1,
            headers: [
                { text: 'TRÁMITE', value: 'tipo', align: 'center', class: 'primary--text text--darken-1', sortable: false },
                { text: 'NRO. TRÁMITE', value: 'nrotramite', align: 'center', class: 'primary--text text--darken-1', sortable: false },
                { text: 'FECHA DE INICIO', value: 'alta', align: 'center', class: 'primary--text text--darken-1', sortable: false },
                { text: 'ACTUALIZACIÓN', value: 'modificado', align: 'center', class: 'primary--text text--darken-1', sortable: false },
                { text: 'ESTADO', value: 'estado', class: "primary--text text--darken-1", align: 'center', sortable: false },
                { text: 'PDF DDJJ', value: 'actions', sortable: false, class: "primary--text text--darken-1", align: 'center' },
                { text: 'ADJUNTOS', value: 'pdfarchivos', sortable: false, class: "primary--text text--darken-1", align: 'center' },
            ],
            desserts: [],
            loading: false,
            descargando: null,
            highlightedTramiteIds: [],
            highlightTimer: null,
            highlightEnabled: false,
        };
    },
    mounted() {
        const fromPlanPago = this.$route?.query?.fromPlanPago;
        if (fromPlanPago) {
            this.highlightEnabled = true;
            const newQuery = { ...this.$route.query };
            delete newQuery.fromPlanPago;
            this.$router.replace({ query: newQuery }).catch(() => { });
        }
    },
    computed: {
        ...mapGetters('tramites', ['misTramites']),
        ...mapGetters('auth', ['isAuthenticated', 'loadSkeleton']),
        filteredItems() {
            if (!this.search) return this.misTramites;

            const searchLower = this.search.toLowerCase();
            return this.misTramites.filter(item => {
                return (
                    (item.tipo && item.tipo.toLowerCase().includes(searchLower)) ||
                    (item.nrotramite && item.nrotramite.toString().toLowerCase().includes(searchLower)) ||
                    (item.alta && item.alta.toLowerCase().includes(searchLower)) ||
                    (item.modificado && item.modificado.toLowerCase().includes(searchLower)) ||
                    (item.estado && item.estado.toLowerCase().includes(searchLower))
                );
            });
        },
        totalPages() {
            return Math.ceil(this.filteredItems.length / this.itemsPerPage);
        },
        paginatedItems() {
            const start = (this.page - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredItems.slice(start, end);
        },
    },
    watch: {
        misTramites: {
            handler(misTramites) {
                if (misTramites && misTramites.length) {
                    this.highlightLatest(misTramites);
                }
            },
            immediate: true,
        },
        itemsPerPage() {
            this.page = 1; // Reset a la primera página cuando cambia el número de items
        },
        search() {
            this.page = 1; // Reset a la primera página cuando se busca
        },
    },
    methods: {
        ...mapActions('tramites', ['getTramites', 'imprimirPdfTramite']),
        getPageRangeText() {
            const start = (this.page - 1) * this.itemsPerPage + 1;
            const end = Math.min(this.page * this.itemsPerPage, this.filteredItems.length);
            return `${start}-${end} de ${this.filteredItems.length}`;
        },
        async descargarPdf(value) {
            if (this.descargando) return;
            this.descargando = value;
            try {
                await this.imprimirPdfTramite(value);
            } finally {
                this.descargando = null;
            }
        },
        getColor(estado) {
            // Asignar colores según la etiqueta del estado
            switch (estado) {
                case 'APROBADO':
                    return 'success'; // o cualquier color que desees
                case 'BAJA':
                    return 'error'; // o cualquier color que desees
                case 'RECHAZADO':
                    return 'error'; // o cualquier color que desees
                // Agregar más casos según sea necesario
                case 'DESESTIMADO':
                    return 'orange'; // o cualquier color que desees
                case 'EN CURSO':
                    return 'primary lighten-2'; // o cualquier color que desees
                case 'PENDIENTE':
                    return 'warning'; // o cualquier color que desees
                default:
                    return 'gray'; // Color predeterminado para otros estados
            }
        },
        traerTramites() {
            this.loading = true;
            this.getTramites().then(() => {
            }).finally(() => {
                this.loading = false;
            });
        },

        highlightLatest(misTramites) {
            if (!this.highlightEnabled) {
                this.highlightedTramiteIds = [];
                this.clearHighlightTimer();
                return;
            }

            const latest = misTramites[0];
            if (!latest || latest.estado !== 'EN CURSO') {
                this.highlightedTramiteIds = [];
                this.clearHighlightTimer();
                return;
            }

            const latestId = latest.nrotramite ?? latest.id ?? latest.tramiteId;
            if (!latestId) {
                return;
            }

            // Construir lista de IDs a resaltar
            const ids = [latestId];

            if (
                latest.tipo === 'Medio de Pagos' &&
                misTramites.length >= 2
            ) {
                const penultimate = misTramites[1];
                if (penultimate?.estado === 'EN CURSO') {
                    const penultimateId = penultimate.nrotramite ?? penultimate.id ?? penultimate.tramiteId;
                    if (penultimateId) {
                        ids.push(penultimateId);
                    }
                }
            }

            if (this.highlightedTramiteIds.join('|') === ids.join('|')) {
                return;
            }

            this.clearHighlightTimer();
            this.highlightedTramiteIds = ids;

            this.$nextTick(() => {
                this.highlightTimer = setTimeout(() => {
                    this.highlightedTramiteIds = [];
                    this.highlightTimer = null;
                    this.highlightEnabled = false;
                }, 4000);
            });
        },

        getItemClass(item) {
            const itemId = item.nrotramite ?? item.id ?? item.tramiteId;
            const highlighted = this.highlightedTramiteIds.includes(itemId);
            const isEnCurso = item.estado === 'EN CURSO';
            return highlighted && isEnCurso ? 'tramite-highlight' : '';
        },

        clearHighlightTimer() {
            if (this.highlightTimer) {
                clearTimeout(this.highlightTimer);
                this.highlightTimer = null;
            }
        }
    },

    beforeDestroy() {
        this.clearHighlightTimer();
    }


}
</script>

<style scoped>
@keyframes tramite-blink-move {

    0%,
    100% {
        background-color: #ffffff;
        transform: translateX(0);
        transform: translateY(0);
    }

    33% {
        background-color: #f1f7ff;
        transform: translateY(-1px);
    }

    66% {
        background-color: #d1e3ff;
        transform: translateY(1px);
    }
}

::v-deep .tramite-highlight,
::v-deep .tramite-highlight>td {
    animation: tramite-blink-move 0.9s ease-in-out 4;
    will-change: background-color, transform;
}
</style>